import { Center, SegmentedControl } from '@mantine/core';
import { IconBrandDocker, IconBrandGithub, IconCode } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export type SourceType = 'url' | 'inline' | 'github';

interface SourceTypeSelectorProps {
    value: SourceType;
    onChange: (value: SourceType) => void;
}

export default function SourceTypeSelector({ value, onChange }: SourceTypeSelectorProps) {
    const { t } = useTranslation('containerEngine');
    return (
        <SegmentedControl
            aria-label={t('deployment.sections.source.title', 'Source')}
            fullWidth
            size="sm"
            radius="md"
            value={value}
            onChange={(next) => onChange(next as SourceType)}
            styles={{
                root: {
                    width: '100%',
                    backgroundColor: 'var(--surface-2)',
                    border: '0.5px solid var(--line)',
                },
            }}
            withItemsBorders={false}
            data={[
                {
                    value: 'url',
                    label: (
                        <Center style={{ gap: 6 }}>
                            <IconBrandDocker size={16} />
                            <span style={{ fontWeight: 400 }}>
                                {t('deployment.sourceTypes.url', 'Container image')}
                            </span>
                        </Center>
                    ),
                },
                {
                    value: 'inline',
                    label: (
                        <Center style={{ gap: 6 }}>
                            <IconCode size={16} />
                            <span style={{ fontWeight: 400 }}>
                                {t('deployment.sourceTypes.inline', 'Inline Dockerfile')}
                            </span>
                        </Center>
                    ),
                },
                {
                    value: 'github',
                    label: (
                        <Center style={{ gap: 6 }}>
                            <IconBrandGithub size={16} />
                            <span style={{ fontWeight: 400 }}>
                                {t('deployment.sourceTypes.github', 'GitHub repository')}
                            </span>
                        </Center>
                    ),
                },
            ]}
        />
    );
}
